import { render, staticRenderFns } from "./brandReplay.vue?vue&type=template&id=1935010a"
import script from "./brandReplay.vue?vue&type=script&lang=js"
export * from "./brandReplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports